<template>
  <div :class="rootClasses">
    <PageHeader
      v-if="!embedded"
      title="About Me"
      :description="profile.moto"
      :breadcrumbs="[{ label: 'Home', to: '/' }, { label: 'About' }]"
    />
    <SectionHeader v-else title="About Me" :description="profile.moto" />

    <div class="grid lg:grid-cols-5 gap-8">
      <BaseCard class="lg:col-span-2" hover>
        <div class="flex flex-col items-center text-center">
          <ProfileAvatar :src="images.profile" alt="Profile photo" size="xl" class="mb-6" />
          <h2 class="text-h3">{{ profile.title }}</h2>
          <BaseBadge variant="success" class="mt-4">Freelance Available</BaseBadge>
        </div>
      </BaseCard>

      <BaseCard class="lg:col-span-3" title="Web Developer" :description="profile.bio">
        <dl class="grid sm:grid-cols-2 gap-4 mt-2">
          <div v-for="item in infoItems" :key="item.label" class="flex flex-col gap-1 p-3 rounded-lg glass-subtle">
            <dt class="text-xs font-medium text-muted uppercase tracking-wide">{{ item.label }}</dt>
            <dd class="text-sm text-foreground">{{ item.value }}</dd>
          </div>
        </dl>
      </BaseCard>
    </div>

    <section class="mt-12">
      <PageHeader
        v-if="!embedded"
        title="Skills"
        description="Technologies and languages I've been building with."
      />
      <SectionHeader
        v-else
        title="Skills"
        description="Technologies and languages I've been building with."
      />
      <div class="grid sm:grid-cols-2 xl:grid-cols-3 gap-8">
        <BaseCard
          v-for="group in skillGroups"
          :key="group.id"
          :title="group.title"
          :description="group.description || undefined"
        >
          <div class="space-y-5 mt-2">
            <BaseProgress
              v-for="skill in group.items"
              :key="`${group.id}-${skill.name}`"
              :label="skill.name"
              :value="skill.level"
            />
          </div>
        </BaseCard>
      </div>
    </section>
  </div>
</template>

<script>
import { siteState } from '@/composables/useSiteData'
import { images } from '@/data/images'
import { calculateAge } from '@/utils/calculateAge'
import { normalizeSkillGroups } from '@/utils/skillGroups'
import PageHeader from '@/components/layout/PageHeader.vue'
import SectionHeader from '@/components/layout/SectionHeader.vue'
import BaseCard from '@/components/ui/BaseCard.vue'
import BaseBadge from '@/components/ui/BaseBadge.vue'
import BaseProgress from '@/components/ui/BaseProgress.vue'
import ProfileAvatar from '@/components/ui/ProfileAvatar.vue'

export default {
  name: 'AboutPage',
  components: { PageHeader, SectionHeader, BaseCard, BaseBadge, BaseProgress, ProfileAvatar },
  props: {
    embedded: Boolean,
  },
  computed: {
    rootClasses() {
      return this.embedded
        ? 'page-container py-16 lg:py-20 animate-fade-in'
        : 'page-container animate-fade-in'
    },
    infoItems() {
      const info = siteState.profile.informations
      return [
        { label: 'Birthday', value: info.birthday },
        { label: 'Age', value: calculateAge(info.birthday) },
        { label: 'Degree', value: info.degree },
        { label: 'Email', value: info.email },
        { label: 'Phone', value: info.contact },
        { label: 'Website', value: info.Website },
        { label: 'Address', value: info.homeaddress },
        { label: 'Freelance', value: info.freelance ? 'Available' : 'Not Available' },
      ]
    },
    profile() {
      return siteState.profile
    },
    skillGroups() {
      return normalizeSkillGroups(siteState.skills)
    },
  },
  data() {
    return {
      siteState,
      images,
    }
  },
}
</script>
